import type { Enums } from "@/integrations/supabase/types";

/** Postgres `public.app_role` values. */
export type AppRole = Enums<"app_role">;

export const Role = {
  Admin: "admin",
  User: "user",
  Employee: "employee",
} as const satisfies Record<string, AppRole>;

export const ROLE_LABELS: Record<AppRole, string> = {
  [Role.User]: "User",
  [Role.Admin]: "Admin",
  [Role.Employee]: "Employee",
};
